import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null); // null = loading, false = anon
  const load = async () => {
    if (!localStorage.getItem("ct_token")) return setAuth(false);
    try {
      const { data } = await api.get("/auth/me");
      setAuth(data);
    } catch {
      localStorage.removeItem("ct_token");
      setAuth(false);
    }
  };
  useEffect(() => { load(); }, []);

  const loginWithToken = (token, data) => {
    localStorage.setItem("ct_token", token);
    setAuth(data);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ct_token");
    setAuth(false);
  };
  return <AuthContext.Provider value={{ auth, setAuth, loginWithToken, logout, reload: load }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
